import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import SubscriptionSummaryImg from './subscription-summary.png';
import { clsx } from 'clsx';
import { StepCount } from './StepCount';
import { ExclusivePriceSetupProps } from '@client/new/common/selfServeExclusive/exclusivePriceSetup';

export const SubscriptionSummary = ({
  next,
  back,
  max,
  step,
  monthly,
  annual,
}: {
  next: () => void;
  back: () => void;
  max: number;
  step: number;
} & Pick<ExclusivePriceSetupProps, 'monthly' | 'annual'>) => {
  return (
    <div className="flex flex-col w-full h-full">
      <StepCount step={step} max={max} />
      <div className="flex flex-col items-center justify-center gap-[23px] w-full h-full">
        <Typography variant="headline" size="large" className="text-center">
          You're all set with a subscription!
        </Typography>
        <div
          className={clsx(
            'flex flex-col rounded-[10px] p-4 gap-2 max-w-[550px]',
            sprinkles({ bg: 'N-10' }),
          )}
        >
          <div className="flex flex-col">
            <Typography
              className="text-center"
              variant="body"
              size="large"
              fontWeight="normal"
            >
              Your Subscription is set to
            </Typography>
            <Typography className="text-center" variant="body" size="large">
              {getPiceInfo({ monthly, annual })}
            </Typography>
          </div>
          <img src={SubscriptionSummaryImg} />
          <Typography
            variant="body"
            size="large"
            fontWeight="normal"
            align="center"
          >
            🚨 You can update your prices in the Settings tab—but only before
            going live! Once live, changes won’t be possible.
          </Typography>
        </div>
      </div>
      <div className="flex justify-between">
        <Button variant="text" color="neutral" onClick={back}>
          Back
        </Button>
        <Button color="neutral" onClick={next}>
          Next
        </Button>
      </div>
    </div>
  );
};

const getPiceInfo = ({
  monthly,
  annual,
}: Pick<ExclusivePriceSetupProps, 'monthly' | 'annual'>) => {
  if (monthly.price && annual.price) {
    return `$ ${monthly.price} / month • $ ${annual.price} / year`;
  }
  return `$ ${monthly.price || annual.price} / ${
    monthly.price ? 'month' : 'year'
  }`;
};
